import { shouldMockBatchAnswer as e } from "../ShouldMockBatchAnswer.js";
import { createMockBatchAnswerDataset as t, createMockBatchAnswerDatasetListResponse as n } from "./BatchAnswerDatasets.mocks.js";
import { API as r, Resource as i } from "@coveo/platform-client";
// src/resources/batch-answer/datasets/BatchAnswerDatasets.resource.ts
var a = 2e3, o = 10, s = class s extends i {
	static {
		this.baseUrl = `/rest/organizations/${r.orgPlaceholder}/answer/v1/datasets`;
	}
	listDataset(t, r) {
		return e(r?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e(n(o, t.page, t.perPage));
			}, a);
		}) : this.api.get(this.buildPath(s.baseUrl, t));
	}
	getDataset(n, r) {
		return e(r?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e(t());
			}, a);
		}) : this.api.get(`${s.baseUrl}/${n.datasetId}`);
	}
	createDataset(n, r) {
		return e(r?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e(t());
			}, a);
		}) : this.api.post(s.baseUrl, n);
	}
	deleteDataset(t, n) {
		return e(n?.isMocking) ? new Promise((e) => {
			setTimeout(() => {
				e();
			}, a);
		}) : this.api.delete(`${s.baseUrl}/${t.datasetId}`);
	}
};
export { s as BatchAnswerDatasetsResource };

//# sourceMappingURL=BatchAnswerDatasets.resource.js.map